"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUERY_CONTENT_BY_IDS = exports.REMOVE_SAVED_ITEM = exports.ADD_SAVED_ITEM = exports.GET_SAVED_ITEMS = void 0;
// GET ALL
const search_queries_1 = require("./search-queries");
exports.GET_SAVED_ITEMS = `
  query getSavedItems($isSavedBlogPostsOnly: Boolean!) {
    getSavedItems(isSavedBlogPostsOnly: $isSavedBlogPostsOnly)
  }
`;
// ADD ITEM
exports.ADD_SAVED_ITEM = `
  mutation addSavedItem($contentId: String!, $contentSource: String!, $isBlogFeed: Boolean) {
    addSavedItem(contentId: $contentId, contentSource: $contentSource, isBlogFeed: $isBlogFeed)
  }
`;
// // REMOVE ITEM
exports.REMOVE_SAVED_ITEM = `
  mutation removeSavedItem($contentId: String!, $contentSource: String!, $isBlogFeed: Boolean) {
    removeSavedItem(contentId: $contentId, contentSource: $contentSource, isBlogFeed: $isBlogFeed)
  }
`;
exports.QUERY_CONTENT_BY_IDS = `
  query getContentByIDs($ids: [String], $sortBy: String, $page: Int, $perPage: Int, $filters: Filters) {
    getContentByIDs(ids: $ids, sortBy: $sortBy, page: $page, perPage: $perPage, filters: $filters) {
      results ${search_queries_1.contentResult},
      meta {
        total,
        perPage,
        page,
        aggs
      }
    }
  }
`;
//# sourceMappingURL=saved-items-queries.js.map